import React, { ReactNode, useMemo } from 'react';

import { ImageGallery } from './ImageGallery';
import { Offer, ProductVariant } from '../../types';
import { TitleSection } from '../elements/TitleSection';
import Icon from '../../icons';

interface Props {
  product: any;
  offer: Offer;
  buyContainer: ReactNode;
  variant?: ProductVariant;
  quantity?: number;
}

function shortenDescription(description: string) {
  const ShortDescriptionRegex =
    /\[short_description\]([\s\S]*)\[\/short_description\]/gm;
  const match = ShortDescriptionRegex.exec(description);
  return match ? match[1] : description;
}

const ProductDetail = ({
  product,
  buyContainer,
  variant,
  offer,
  quantity = 1,
}: Props) => {
  const { images, description, icon } = product;

  const selectedImage = useMemo(() => {
    // incoming image can have prefix 'https:' or images can have it, so this is the unification for later selection
    if (images) {
      const cleanedImage =
        variant?.featured_image?.src.replace('https:', '') || '';
      return images.find((image: string) => image.includes(cleanedImage))
        ? cleanedImage
        : images[0];
    }
  }, [images, variant]);

  return (
    <div className="px-30 pb-30 pt-20 md:pt-10 md:flex">
      <div className="md:hidden">
        <TitleSection
          productOrServiceOffer={product}
          offer={offer}
          variant={variant}
          quantity={quantity}
        />
      </div>

      <div className="md:w-250 md:min-w-250 md:mr-30 bg-transparent relative md:absolute">
        <div>
          {images && (
            <ImageGallery images={images} preferredImage={selectedImage} />
          )}
          {icon && (
            <div className="bg-grey-5 w-full flex items-center justify-center md:h-150 mt-10 mb-10 md:mt-none Detail-Icon">
              <Icon key={icon} name={icon} className="h-70 w-70" />
            </div>
          )}
        </div>
      </div>

      <div className="md:overflow-y-auto flex flex-col md:ml-250 md:pl-30 md:min-w-300">
        <div className="hidden md:block order-1">
          <TitleSection
            productOrServiceOffer={product}
            offer={offer}
            variant={variant}
            quantity={quantity}
          />
        </div>
        <p
          className="Description mt-20 mb-10 order-3 text-sm text-grey-1 break-words-and-add-overflow-wrap"
          dangerouslySetInnerHTML={{
            __html: shortenDescription(description),
          }}
        />
        <div className="order-2 block space-y-10 md:max-w-270 md:mt-10">
          {buyContainer}
        </div>
      </div>
    </div>
  );
};

export default ProductDetail;
